// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./css/login.css";
// import { tokens } from "../../theme/theme";
// import { InputAdornment } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { API_ENDPOINTS } from "../../config/api/apiCall";
// import { Box, Card, Grid, useTheme, Checkbox, FormControlLabel, TextField, Typography, IconButton, Button } from "@mui/material";
// import axios from 'axios';
// import logo from "../../assets/papyrus3602.png"; // Logo file (adjust path as needed)
// import loginIllustration from "../../assets/add table space my p.png"; // You can use the same image as your reference (optional)


// import YouTubeIcon from "@mui/icons-material/YouTube";
// import GoogleIcon from "@mui/icons-material/Google";
// import FacebookIcon from '@mui/icons-material/Facebook';
// import { callApi } from "../../utils/apiClient";
// //import bpapplogo from "../../assets/bpapp with papyrus logo.png"; // You can use the same image as your reference (optional)../../../assets/images/transparent_bp_app.png
// import bpapplogo from "../../assets/Transparent_bp_app.png";



// const Login = ({ onLogin }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [ip, setIp] = useState("");
//   const [city, setCity] = useState("");
//   const [validationMessage, setValidationMessage] = useState(""); // New state for validation message
//   const [rememberMe, setRememberMe] = useState(false); // State for Remember Me option

//   useEffect(() => {
//     const fetchIp = async () => {
//       try {
//         // Step 1: Fetch IP address
//         const response = await axios.get("https://api.ipify.org?format=json");
//         const userIp = response.data.ip;
//         setIp(userIp);

//         // Step 2: Fetch city using the IP address
//         const locationResponse = await axios.get(`https://ipinfo.io/${userIp}/geo?token=your_token_here`);
//         const userCity = locationResponse.data.city;
//         setCity(userCity);
//       } catch (error) {
//         console.error("Error fetching IP address or city information", error);
//       }
//     };
//     fetchIp();

//     // Check if username is stored in localStorage
//     const savedUsername = localStorage.getItem("rememberedUsername");
//     if (savedUsername) {
//       setUsername(savedUsername);
//       setRememberMe(true); // Set checkbox as checked
//     }
//   }, []);

//   const navigate = useNavigate();

//   const handleUsernameChange = (e) => {
//     setUsername(e.target.value);
//     setValidationMessage(""); // Clear message when user starts typing
//   };

//   const handlePasswordChange = (e) => {
//     setPassword(e.target.value);
//     setValidationMessage(""); // Clear message when user starts typing
//   };

//   const handleRememberMeChange = (e) => {
//     setRememberMe(e.target.checked);
//   };


//   const handleLogin = () => {

//     // Check if email and password are provided
//     if (!username || !password) {
//       setValidationMessage("Please enter both username and password.");
//       return;
//     }

//     // Prepare the login data to be sent to the server
//     const requestBody = { userid: username, password: password, ip: ip, location_city: city };

//     callApi(API_ENDPOINTS.USER_getUserDataExistsOrNot, 'POST', { 'Content-Type': 'application/json' }, requestBody)
//       .then(data => {

//         // Check if data contains valid credentials
//         if (data.length > 0 && data[0].isactive) {

//           const validationMsg = data[0].validatemessage;

//           // Save the validation message regardless
//           localStorage.setItem("ValidationMessage", validationMsg);

//           if (
//             !validationMsg ||
//             validationMsg ===
//             "Your subscription period has expired, but you are within the 15-day grace period. Please contact support@papyrus360.com to renew."
//           ) {
//             localStorage.setItem("userID", username);
//             localStorage.setItem("userPassword", password);
//             localStorage.setItem("companyid", data[0].companyid);
//             localStorage.setItem("employeeID", data[0].id_employee);
//             localStorage.setItem("companyCountry",  data[0].company_country);
//             localStorage.setItem("companyState",  data[0].company_state);
//             localStorage.setItem("LoginID", data[0].id);
//             rememberMe
//               ? localStorage.setItem("rememberedUsername", username)
//               : localStorage.removeItem("rememberedUsername");

//             onLogin();
//             navigate("/");
//           } else {
//             setValidationMessage(validationMsg);
//           }


//         } else {
//           setValidationMessage("Invalid login credentials. Please try again.");
//         }

//       })
//       .catch(error => {
//         console.error(error);
//         setValidationMessage("An error occurred during login. Please try again.");
//       });

//   };

//   const [showPassword, setShowPassword] = useState(false);

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault(); // Prevents focusing on the button when clicked
//   };


//   return (

//     <Box
//       sx={{
//         minHeight: '100vh',
//         backgroundColor: '#151a3aff',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         px: 2,
//       }}
//     >
//       {/* Logo in Top-Left */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: 20,
//           left: 30,
//         }}
//       >
//         <img src={bpapplogo} alt="papyrus Logo" style={{ height: 60 }} />
//       </Box>



//       <Card sx={{
//         display: 'flex',
//         borderRadius: 4,
//         boxShadow: 6,
//         overflow: 'hidden',
//         maxWidth: 1000,
//         width: '100%',
//       }}>
//         {/* Left illustration */}
//         <Box
//           sx={{
//             flex: 1,
//             backgroundColor: '#a72323ff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             p: 4
//           }}
//         >

//           <img
//             src={logo}
//             alt="Illustration"
//             style={{
//               width: "110%",
//               height: "110%",
//               objectFit: "contain",
//             }}
//           />
//         </Box>

//         {/* Right form */}
//         <Box
//           sx={{
//             flex: 1,
//             backgroundColor: 'white',
//             color: 'black',
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             p: 4
//           }}
//         >
//           <Typography variant="h5" fontWeight="bold" mb={1}>
//             Welcome Back :)
//           </Typography>
//           <Typography variant="body2" mb={3} color="black" >
//             To keep connected with us, please login with your email and password.
//           </Typography>

//           <TextField
//             label="Email Address"
//             type="email"
//             fullWidth
//             size="small"
//             margin="normal"
//             value={username}
//             onChange={handleUsernameChange}
//             sx={{
//               input: { color: 'black' }, // text inside input
//               label: { color: 'black' }, // label color when not focused
//               '& label.Mui-focused': { color: 'black' }, // label color when focused
//               '& .MuiOutlinedInput-root': {
//                 '& fieldset': {
//                   borderColor: 'black', // default border
//                 },
//                 '&:hover fieldset': {
//                   borderColor: 'black', // on hover
//                 },
//                 '&.Mui-focused fieldset': {
//                   borderColor: 'black', // on focus
//                 },
//               },
//             }}
//           />
//           <TextField
//             label="Password"
//             type={showPassword ? 'text' : 'password'}
//             fullWidth
//             size="small"
//             margin="normal"
//             value={password}
//             onChange={handlePasswordChange}
//             sx={{
//               input: { color: 'black' }, // text inside input
//               label: { color: 'black' }, // label color when not focused
//               '& label.Mui-focused': { color: 'black' }, // label color when focused
//               '& .MuiOutlinedInput-root': {
//                 '& fieldset': {
//                   borderColor: 'black', // default border
//                 },
//                 '&:hover fieldset': {
//                   borderColor: 'black', // on hover
//                 },
//                 '&.Mui-focused fieldset': {
//                   borderColor: 'black', // on focus
//                 },
//               },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               )
//             }}
//           />

//           <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
//             <FormControlLabel
//               control={<Checkbox checked={rememberMe} color="secondary" onChange={handleRememberMeChange} />}
//               label="Remember Me"
//             />
//             <Typography variant="body2" sx={{ cursor: 'pointer', color: '#007BFF' }}>
//               Forgot Password?
//             </Typography>
//           </Box>

//           {validationMessage && (
//             <Typography variant="body2" color="error" mt={1}>
//               {validationMessage}
//             </Typography>
//           )}

//           <Button
//             fullWidth
//             variant="contained"
//             color="secondary"
//             sx={{ mt: 2, textTransform: 'none', borderRadius: 2 }}
//             onClick={handleLogin}
//           >
//             Login Now
//           </Button>



//           <Typography textAlign="center" mt={3} mb={1}>
//             Or you can join with
//           </Typography>          
//           <Box display="flex" justifyContent="center" gap={2} mt={2}>
//             <a href="https://www.papyrus360.com/360/" target="_blank" rel="noopener noreferrer">
//               <IconButton color="primary">
//                 <GoogleIcon fontSize="large" />
//               </IconButton>
//             </a>
//             <a href="https://www.youtube.com/watch?v=CnK2a99N-nY" target="_blank" rel="noopener noreferrer">
//               <IconButton color="error">
//                 <YouTubeIcon fontSize="large" />
//               </IconButton>
//             </a>
//             <a href="https://www.facebook.com/profile.php?id=100065278642672" target="_blank" rel="noopener noreferrer">
//               <IconButton color="secondary">
//                 <FacebookIcon fontSize="large" />
//               </IconButton>
//             </a>
//           </Box>
//         </Box>
//       </Card>
//     </Box>



//   );
// };

// export default Login;


// import { useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Paper,
//   Divider,
//   Checkbox,
//   FormControlLabel,
//   Link,
//   Grid,
//   InputAdornment,
//   IconButton,
//   Container
// } from "@mui/material";
// import {
//   Visibility,
//   VisibilityOff,
//   Lock,
//   Email,
//   Google,
//   Facebook
// } from "@mui/icons-material";

// export default function Login() {
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: "",
//     password: ""
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Login attempt:", formData);
//     // Handle login logic here
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <Box sx={{ minHeight: '100vh', display: 'flex' }}>
//       {/* Left side - Background Image */}
//       <Box
//         sx={{
//           display: { xs: 'none', lg: 'flex' },
//           width: { lg: '50%' },
//           position: 'relative',
//           backgroundImage: 'url(https://images.unsplash.com/photo-1630283017802-785b7aff9aac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MXx8fHwxNzU5ODUxNTU1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral)',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.4)',
//           }
//         }}
//       >
//         <Box
//           sx={{
//             position: 'relative',
//             zIndex: 1,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             color: 'white',
//             textAlign: 'center',
//             p: 4
//           }}
//         >
//           <Box>
//             <Typography variant="h3" component="h1" gutterBottom>
//               Welcome Back
//             </Typography>
//             <Typography variant="body1" sx={{ opacity: 0.8 }}>
//               Sign in to your account to continue your journey with us.
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* Right side - Login Form */}
//       <Box
//         sx={{
//           width: { xs: '100%', lg: '50%' },
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           p: 3,
//           backgroundColor: '#ffffff'
//         }}
//       >
//         <Container maxWidth="sm">
//           <Box sx={{ width: '100%', maxWidth: 400, mx: 'auto' }}>
//             {/* Logo/Brand Section */}
//             <Box sx={{ textAlign: 'center', mb: 4 }}>
//               <Box
//                 sx={{
//                   width: 48,
//                   height: 48,
//                   backgroundColor: '#030213',
//                   borderRadius: 1.5,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   mx: 'auto',
//                   mb: 2
//                 }}
//               >
//                 <Lock sx={{ color: 'white', fontSize: 24 }} />
//               </Box>
//               <Typography variant="h4" component="h2" gutterBottom>
//                 Sign in to your account
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Enter your credentials to access your account
//               </Typography>
//             </Box>

//             {/* Login Form */}
//             <Paper
//               elevation={1}
//               sx={{
//                 p: 3,
//                 border: '1px solid rgba(0, 0, 0, 0.1)',
//                 borderRadius: 2
//               }}
//             >
//               <Typography variant="h5" component="h3" gutterBottom>
//                 Login
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//                 Enter your email and password to sign in
//               </Typography>

//               <Box component="form" onSubmit={handleSubmit}>
//                 {/* Email Field */}
//                 <TextField
//                   fullWidth
//                   id="email"
//                   name="email"
//                   label="Email"
//                   type="email"
//                   placeholder="Enter your email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   sx={{ mb: 2 }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Email sx={{ color: 'text.secondary' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />

//                 {/* Password Field */}
//                 <TextField
//                   fullWidth
//                   id="password"
//                   name="password"
//                   label="Password"
//                   type={showPassword ? 'text' : 'password'}
//                   placeholder="Enter your password"
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   sx={{ mb: 2 }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Lock sx={{ color: 'text.secondary' }} />
//                       </InputAdornment>
//                     ),
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton
//                           aria-label="toggle password visibility"
//                           onClick={handleClickShowPassword}
//                           edge="end"
//                         >
//                           {showPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />

//                 {/* Remember Me & Forgot Password */}
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                   <FormControlLabel
//                     control={<Checkbox size="small" />}
//                     label={
//                       <Typography variant="body2" color="text.secondary">
//                         Remember me
//                       </Typography>
//                     }
//                   />
//                   <Link href="#" variant="body2" color="primary">
//                     Forgot password?
//                   </Link>
//                 </Box>

//                 {/* Submit Button */}
//                 <Button
//                   type="submit"
//                   fullWidth
//                   variant="contained"
//                   sx={{
//                     mb: 3,
//                     backgroundColor: '#030213',
//                     '&:hover': {
//                       backgroundColor: '#1a1a2e',
//                     },
//                     py: 1.5
//                   }}
//                 >
//                   Sign In
//                 </Button>
//               </Box>

//               {/* Divider */}
//               <Box sx={{ position: 'relative', my: 3 }}>
//                 <Divider />
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     backgroundColor: 'white',
//                     px: 2,
//                     color: 'text.secondary',
//                     textTransform: 'uppercase'
//                   }}
//                 >
//                   Or continue with
//                 </Typography>
//               </Box>

//               {/* Social Login Buttons */}
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={6}>
//                   <Button
//                     fullWidth
//                     variant="outlined"
//                     startIcon={<Google />}
//                     sx={{ py: 1.5 }}
//                   >
//                     Google
//                   </Button>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Button
//                     fullWidth
//                     variant="outlined"
//                     startIcon={<Facebook />}
//                     sx={{ py: 1.5 }}
//                   >
//                     Facebook
//                   </Button>
//                 </Grid>
//               </Grid>

//               {/* Sign Up Link */}
//               <Box sx={{ textAlign: 'center' }}>
//                 <Typography variant="body2" color="text.secondary">
//                   Don't have an account?{' '}
//                   <Link href="#" color="primary">
//                     Sign up here
//                   </Link>
//                 </Typography>
//               </Box>
//             </Paper>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// }



import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./css/login.css";
import { tokens } from "../../theme/theme";
import { InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff, Lock, Email } from '@mui/icons-material';
import { API_ENDPOINTS } from "../../config/api/apiCall";
import { Box, Card, Grid, useTheme, Checkbox, FormControlLabel, TextField, Typography, IconButton, Button, Container, Link, Divider } from "@mui/material";
import axios from 'axios';
//import bpapplogo from "../../assets/Transparent_bp_app.png";
import bpapplogo from "../../assets/bp_app_celebration_logo.png";
import bglogin from "../../assets/login_bg.png"
// import { ImageWithFallback } from './components/figma/ImageWithFallback';

import YouTubeIcon from "@mui/icons-material/YouTube";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from '@mui/icons-material/Facebook';
import { callApi } from "../../utils/apiClient";
import { motion } from 'framer-motion';

// import { Player } from '@lordicon/react';



const Login = ({ onLogin }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [ip, setIp] = useState("");
  const [city, setCity] = useState("");
  const [validationMessage, setValidationMessage] = useState(""); // New state for validation message
  const [rememberMe, setRememberMe] = useState(false); // State for Remember Me option

  // const ICON = require('./assets/your-icon.json'); // Or direct URL: 'https://cdn.lordicon.com/...json'

  // icon animation 




  useEffect(() => {
    const fetchIp = async () => {
      try {
        // Step 1: Fetch IP address
        const response = await axios.get("https://api.ipify.org?format=json");
        const userIp = response.data.ip;
        setIp(userIp);

        // Step 2: Fetch city using the IP address
        const locationResponse = await axios.get(`https://ipinfo.io/${userIp}/geo?token=your_token_here`);
        const userCity = locationResponse.data.city;
        setCity(userCity);
      } catch (error) {
        console.error("Error fetching IP address or city information", error);
      }
    };
    fetchIp();

    // Check if username is stored in localStorage
    const savedUsername = localStorage.getItem("rememberedUsername");
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true); // Set checkbox as checked
    }
  }, []);

  const navigate = useNavigate();

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    setValidationMessage(""); // Clear message when user starts typing
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setValidationMessage(""); // Clear message when user starts typing
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const handleLogin = () => {
    // Check if email and password are provided
    if (!username || !password) {
      setValidationMessage("Please enter both username and password.");
      return;
    }

    // Prepare the login data to be sent to the server
    const requestBody = { userid: username, password: password, ip: ip, location_city: city };

    callApi(API_ENDPOINTS.USER_getUserDataExistsOrNot, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Check if data contains valid credentials
        if (data.length > 0 && data[0].isactive) {
          const validationMsg = data[0].validatemessage;

          // Save the validation message regardless
          localStorage.setItem("ValidationMessage", validationMsg);

          if (
            !validationMsg ||
            validationMsg ===
            "Your subscription period has expired, but you are within the 15-day grace period. Please contact support@papyrus360.com to renew."
          ) {
            localStorage.setItem("userID", username);
            localStorage.setItem("userPassword", password);
            localStorage.setItem("companyid", data[0].companyid);
            localStorage.setItem("employeeID", data[0].id_employee);
            localStorage.setItem("companyCountry", data[0].company_country);
            localStorage.setItem("companyState", data[0].company_state);
            localStorage.setItem("is_system_admin", data[0].is_system_admin);

            rememberMe
              ? localStorage.setItem("rememberedUsername", username)
              : localStorage.removeItem("rememberedUsername");

            onLogin();
            navigate("/");
          } else {
            setValidationMessage(validationMsg);
          }
        } else {
          setValidationMessage("Invalid login credentials. Please try again.");
        }
      })
      .catch(error => {
        console.error(error);
        setValidationMessage("An error occurred during login. Please try again.");
      });
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault(); // Prevents focusing on the button when clicked
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex' }}>
      {/* Left side - Background Image */}
      {/* <Box
        
        sx={{
          display: { xs: 'none', lg: 'flex' },
          width: { lg: '50%' },
          position: 'relative',
          backgroundImage: 'url(https://images.unsplash.com/photo-1630283017802-785b7aff9aac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MXx8fHwxNzU5ODUxNTU1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          }
        }}
      >
       
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box sx={{ color: 'white', textAlign: 'center', p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom>
              Welcome Back
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.8 }}>
              Sign in to your account to continue your journey with us.
            </Typography>
          </Box>
        </Box>
      </Box> */}

      {/* Right side - Login Form */}
      {/* <Box
        sx={{
          width: { xs: '100%', lg: '50%' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          backgroundColor: '#ffffff'
        }}
      > */}

    

      <Box
        sx={{
          minHeight: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: theme.palette.mode === 'dark'
            ? `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[400]} 100%)`
            : `linear-gradient(135deg, ${colors.primary[200]} 0%, ${colors.primary[300]} 100%)`,
          backgroundAttachment: "fixed",
          position: "relative",
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: theme.palette.mode === 'dark'
              ? "radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%)"
              : "radial-gradient(circle at 20% 50%, rgba(79, 172, 254, 0.1) 0%, transparent 50%)",
            pointerEvents: 'none'
          }
        }}
      >
        <Container maxWidth="sm" sx={{
          p: 0,
          display: "flex",
          justifyContent: "center",
          position: 'relative',
          zIndex: 1
        }}>
          <Box sx={{ width: '100%', maxWidth: 420, mx: 'auto' }}>
            {/* Logo/Brand Section */}
            <Box sx={{ textAlign: 'center', mb: 5 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 4,
                }}
              >
                <motion.div
                  whileHover={{
                    scale: 1.05,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <img src={bpapplogo} alt="Company Logo" style={{ height: 80, width: 'auto' }} />
                </motion.div>
              </Box>
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'dark' ? colors.grey[100] : colors.primary[600],
                  fontSize: { xs: '1.75rem', sm: '2rem' },
                  letterSpacing: '-0.5px'
                }}
              >
                Welcome Back
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.mode === 'dark' ? colors.grey[300] : colors.primary[700],
                  fontSize: '0.95rem',
                  fontWeight: 400
                }}
              >
                Sign in to your ERP account to continue
              </Typography>
            </Box>

            {/* Login Form Card */}
            <Card
              sx={{
                p: 4,
                border: 'none',
                borderRadius: 3,
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.06)',
                backgroundColor: theme.palette.mode === 'dark' ? colors.primary[400] : '#ffffff',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  boxShadow: '0 15px 50px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)'
                }
              }}
            >
              <Box component="form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                {/* Email Field */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="body2"
                    component="label"
                    htmlFor="email"
                    sx={{
                      mb: 1.5,
                      display: 'block',
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? colors.grey[100] : colors.primary[600],
                      fontSize: '0.9rem'
                    }}
                  >
                    Email Address
                  </Typography>
                  <TextField
                    id="email"
                    name="email"
                    type="email"
                    placeholder="name@company.com"
                    value={username}
                    onChange={handleUsernameChange}
                    fullWidth
                    size="medium"
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: colors.blueAccent[500], fontSize: 18 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 48,
                        fontSize: '0.95rem',
                        '& fieldset': {
                          borderColor: theme.palette.mode === 'dark' ? colors.primary[600] : colors.primary[300],
                          borderWidth: '1.5px'
                        },
                        '&:hover fieldset': {
                          borderColor: colors.blueAccent[500],
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.blueAccent[500],
                          borderWidth: '2px'
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        color: theme.palette.mode === 'dark' ? colors.grey[100] : colors.primary[600],
                        '&::placeholder': {
                          color: theme.palette.mode === 'dark' ? colors.grey[500] : colors.primary[800],
                          opacity: 1
                        }
                      }
                    }}
                  />
                </Box>

                {/* Password Field */}
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography
                      variant="body2"
                      component="label"
                      htmlFor="password"
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.mode === 'dark' ? colors.grey[100] : colors.primary[600],
                        fontSize: '0.9rem'
                      }}
                    >
                      Password
                    </Typography>
                  </Box>
                  <TextField
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={password}
                    onChange={handlePasswordChange}
                    fullWidth
                    size="medium"
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock sx={{ color: colors.blueAccent[500], fontSize: 18 }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="small"
                            sx={{ color: theme.palette.mode === 'dark' ? colors.grey[300] : colors.primary[700] }}
                          >
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 48,
                        fontSize: '0.95rem',
                        '& fieldset': {
                          borderColor: theme.palette.mode === 'dark' ? colors.primary[600] : colors.primary[300],
                          borderWidth: '1.5px'
                        },
                        '&:hover fieldset': {
                          borderColor: colors.blueAccent[500],
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.blueAccent[500],
                          borderWidth: '2px'
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        color: theme.palette.mode === 'dark' ? colors.grey[100] : colors.primary[600],
                        '&::placeholder': {
                          color: theme.palette.mode === 'dark' ? colors.grey[500] : colors.primary[800],
                          opacity: 1
                        }
                      }
                    }}
                  />
                </Box>

                {/* Remember Me & Forgot Password */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                        size="small"
                        sx={{
                          color: theme.palette.mode === 'dark' ? colors.primary[600] : colors.primary[300],
                          '&.Mui-checked': {
                            color: colors.blueAccent[500],
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: theme.palette.mode === 'dark' ? colors.grey[300] : colors.primary[700], fontSize: '0.9rem' }}>
                        Remember me
                      </Typography>
                    }
                  />
                  <Link
                    href="#"
                    variant="body2"
                    sx={{
                      color: colors.blueAccent[500],
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      fontWeight: 500,
                      '&:hover': {
                        textDecoration: 'underline',
                        color: colors.blueAccent[600]
                      }
                    }}
                  >
                    Forgot password?
                  </Link>
                </Box>

                {/* Validation Message */}
                {validationMessage && (
                  <Box sx={{
                    mb: 2.5,
                    p: 2,
                    bgcolor: theme.palette.mode === 'dark'
                      ? 'rgba(244, 67, 54, 0.15)'
                      : 'rgba(244, 67, 54, 0.08)',
                    border: `1px solid ${colors.redAccent[500]}`,
                    borderRadius: 1.5
                  }}>
                    <Typography variant="body2" sx={{ color: colors.redAccent[500], fontSize: '0.85rem' }}>
                      {validationMessage}
                    </Typography>
                  </Box>
                )}

                {/* Submit Button */}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  onClick={handleLogin}
                  sx={{
                    mb: 2,
                    py: 1.5,
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    letterSpacing: '0.3px',
                    background: `linear-gradient(135deg, ${colors.blueAccent[500]} 0%, ${colors.blueAccent[600]} 100%)`,
                    boxShadow: `0 4px 15px ${colors.blueAccent[500]}40`,
                    transition: 'all 0.3s ease',
                    borderRadius: 2,
                    '&:hover': {
                      background: `linear-gradient(135deg, ${colors.blueAccent[600]} 0%, ${colors.blueAccent[700]} 100%)`,
                      boxShadow: `0 6px 20px ${colors.blueAccent[500]}60`,
                      transform: 'translateY(-2px)'
                    },
                    '&:active': {
                      transform: 'translateY(0)'
                    }
                  }}
                >
                  Sign In
                </Button>
              </Box>

              {/* Sign Up Link */}
              <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Typography variant="body2" sx={{ color: theme.palette.mode === 'dark' ? colors.grey[300] : colors.primary[700], fontSize: '0.9rem' }}>
                  Need help? Contact{' '}
                  <Link
                    href="mailto:support@papyrus360.com"
                    sx={{
                      color: colors.blueAccent[500],
                      textDecoration: 'none',
                      fontWeight: 600,
                      '&:hover': { textDecoration: 'underline' }
                    }}
                  >
                    support
                  </Link>
                </Typography>
              </Box>
            </Card>

            {/* Footer Note */}
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography variant="caption" sx={{ color: theme.palette.mode === 'dark' ? colors.grey[500] : colors.primary[800], fontSize: '0.8rem' }}>
                Secure login • Protected by industry-standard encryption
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
      {/* </Box> */}
    </Box>
  );
};

export default Login;